export const ClassificationStatus = Object.freeze({
	NORMAL: "normal",
	EDITED: "edited",
	ARCHIVED: "archived",
	UNARCHIVE: "unarchived",
	NEW: "new",
});

export const ClassificationAction = Object.freeze({
	EMPTY: "empty",
	ARCHIVE: "archive",
	UNARCHIVE: "unarchive",
	DELETE: "delete",
});

export const getTextStyle = (status, isArchived = false) => {
	if (status === ClassificationStatus.UNARCHIVE) {
		return { color: "#52c41a" }; // Verde para desarchivados
	}
	
	if (isArchived) {
		return { color: "#8c8c8c", textDecoration: "line-through" }; // Gris con tachado
	}
	
	switch (status) {
	case ClassificationStatus.EDITED:
		return { color: "#faad14" }; // Amarillo para editados
	case ClassificationStatus.ARCHIVED:
		return { color: "#8c8c8c", textDecoration: "line-through" }; // Gris subrayado para archivados
	default:
		return {};
	}
};